import React from 'react';
import styles from './teamSubmission.module.scss';

export default class TeamSubmissionDropdown extends React.Component{
    constructor(props){
        super(props);
        this.getOptions = this.getOptions.bind(this);
        this.getCurrentContractId = this.getCurrentContractId.bind(this);
    }

    getCurrentContractId() {
        return this.props.Selected || '';
    }


    getOptions() {
        if (this.props.ContractPlayers.length === 0){
            return (<option>Loading...</option>);
        }

        return [(<option key={'default'}>--Select a player--</option>)]
            .concat(this.props.ContractPlayers.map(c => {
                return (
                    <option key={`contract-${c.contract.id}`} 
                            value={c.contract.id}>{c.player.firstName} {c.player.lastName}</option>
                );
            }));
    }

    render(){
        const currentId = this.getCurrentContractId();
        var style = styles.teamSubmissionDropdown;
        if (currentId && (this.props.Errors || []).filter(e => 
            e.code === 'DupPlayer' 
            && e.data.playerContract.contract.id === currentId).length > 0){
            style = styles.teamSubmissionDropdownError;
        }


        return(
        <div className={style}>
            <select name={this.props.Position} 
                    value={currentId} 
                    onChange={this.props.OnChange}>
                {this.getOptions()}
            </select>
        </div>
    );}
}